import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconRepost = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M19 7a1 1 0 0 0-1-1h-8v2h7v5h-3l3.969 5L22 13h-3V7zM5 17a1 1 0 0 0 1 1h8v-2H7v-5h3L6 6l-4 5h3v6z" }, void 0) }, void 0));
const Memo = memo(SvgIconRepost);
export default Memo;
//# sourceMappingURL=IconRepost.js.map